import React, {useEffect, useState} from 'react'
import {Table, Switch, Modal, message} from 'antd'
import {ExclamationCircleTwoTone} from '@ant-design/icons';
import {inject, observer} from 'mobx-react'
import {queryClientList, getMediaWallList, controlClient} from '@apis'
import centerBg from '../../../assets/img/mapBg1.png'

let timer

const ClientManagement = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {strongProjectId: projectId} = userInfo
    const [clientList, setClientList] = useState([])
    const [loading, setLoading] = useState(false)

    // 获取节点信息
    async function queryMediaWallList() {
      const params = {
        projectId,
        pageNo: 1,
        pageSize: 999,
      }
      const res = await getMediaWallList(params)
      if (res && res.data) {
        getClientList(res.data)
      }
    }

    // 获取节点监控信息
    async function getClientList(nodeList) {
      const params = {
        projectId,
        pageNo: 1,
        pageSize: 999,
      }
      const res = await queryClientList(params)
      if (res && res.data) {
        let client = []
        nodeList.map(item => {
          res.data.data.map(value => {
            if(value.appCode == item.code) {
              client.push({
                ...value,
                id: item.id,
                name: item.name
              })
            }
          })
        })
        setClientList(client)
      }
    }

    function remind(record, value) {
      setLoading(true)
      const data = [
        {name:'开启屏幕锁定', params: '&lock=true'},
        {name:'关闭屏幕锁定', params: '&unlock=true'},
        {name:'开启GP', params: '&launchEP=true'},
        {name:'关闭GP', params: '&killEP=true'},
        {name:'开启授时器', params: '&launchTimeSync=true'},
        {name:'关闭授时器', params: '&killTimeSync=true'},
        {name:'开启节点端', params: '&launchDesktop=true'},
        {name:'关闭节点端', params: '&killDesktop=true'},
      ]
      Modal.confirm({
        title: '提示',
        icon: <ExclamationCircleTwoTone />,
        content: '确定'+ data[value].name + '?',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          setLoading(false)
          if(new Date(record.dateTime).valueOf()+ 5*60*1000 < new Date().valueOf()) return message.warning('监控已离线，无法进行操作!')
          controlClient("appCode="+record.appCode+data[value].params).then(res => {message.success('命令已发送')})
        }
      });
    }

    useEffect(() => {
      clearInterval(timer)
      timer = setInterval(() => {
        queryMediaWallList()
      }, 1000)
    }, [])

    const columns = [{
      title: '编号',
      key: 'id',
      dataIndex: 'id',
    }, {
      title: '分节点名称',
      key: 'name',
      dataIndex: 'name',
    }, {
      title: '锁定状态',
      key: 'locked',
      render: row => {
        return (
          <Switch
            checked={row.locked === true}
            checkedChildren="是"
            unCheckedChildren="否"
            onChange={e => {
              remind(row, e ? 0 : 1)
            }}
          />
        )
      }
    }, {
      title: 'GP运行状态',
      key: 'runningEP',
      render: row => {
        return (
          <Switch
            checked={row.runningEP === true}
            checkedChildren="是"
            unCheckedChildren="否"
            onChange={e => {
              remind(row, e ? 2 : 3)
            }}
          />
        )
      }
    }, {
      title: '授时器运行状态',
      key: 'runningTimeSync',
      render: row => {
        return (
          <Switch
            checked={row.runningTimeSync === true}
            checkedChildren="是"
            unCheckedChildren="否"
            onChange={e => {
              remind(row, e ? 4 : 5)
            }}
          />
        )
      }
    }, {
      title: '节点端运行状态',
      key: 'runningDesktop',
      render: row => {
        return (
          <Switch
            checked={row.runningDesktop}
            checkedChildren="是"
            unCheckedChildren="否"
            onChange={e => {
              remind(row, e ? 6 : 7)
            }}
          />
        )
      }
    }, {
      title: '节点离线状态',
      key: 'dateTime',
      render: row => {
        if(new Date(row.dateTime).valueOf()+ 5*60*1000 < new Date().valueOf()) {
          return <div>离线</div>
        }
        return <div>在线</div>
      }
    }]
  
    return (
      <React.Fragment>
        <img src={centerBg} className='client-img'/>
        <Table
          className='client-table'
          title={() => '灯光管理/安全管理'}
          columns={columns}
          dataSource={clientList}
          loading={loading}
          pagination={{
            position: ['topRight'],
            showSizeChanger: false
          }}
        />
      </React.Fragment>
    )
  })
)

export default ClientManagement
